import { useGetNMIApplicationDetails } from "@faire/deprecated-retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/useGetNMIApplicationDetails";
import { useOpenWithFaireApplicationStatus } from "@faire/deprecated-retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";
import { IRetailerLaunchWithFaire as IOpenWithFaire } from "@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaire";
import confirmIdentity from "@faire/web-api--source/routes/www/confirm-identity";
import openWithFaireNMIRoute from "@faire/web-api--source/routes/www/open-with-faire-additional-info";
import underwritingInformation from "@faire/web-api--source/routes/www/underwriting-information";

export const useCompleteStoreProfileUrl = () => {
  const { hasPendingOwfUwRequest, status } =
    useOpenWithFaireApplicationStatus();
  const isOnHold = status === IOpenWithFaire.Status.ON_HOLD;
  const { isFrozenCreditNMI, isNoHitNMI } = useGetNMIApplicationDetails();
  const hasNMIApplication = isFrozenCreditNMI || isNoHitNMI || isOnHold;

  if (hasNMIApplication) {
    return openWithFaireNMIRoute();
  }

  return hasPendingOwfUwRequest ? underwritingInformation() : confirmIdentity();
};
